// extracted by mini-css-extract-plugin
module.exports = {"container":"packageCard_container__2losS"};